<div class="tab-divider"></div>

<div class="row top-div">
    <div class="div-container" *ngFor="let data of uploadTestCaseData">
      <div class="section-header">
        <div class="number-circle">{{ data.id }}</div>
        <span class="section-title">{{ data.title }}</span>
      </div>
  
      <div class="input-container" *ngIf="data.dropDownOptions">
        <div class="row">
          <span class="data-label"
            >{{ data.dropDownLabel }}
            <i
              class="bi bi-info-circle"
              title="Information"
              *ngIf="data.infoUrl"
            ></i>
          </span>
        </div>
        <select
          class="dropdown-select"
          [(ngModel)]="data.selectedOption"
          (change)="onDropdownChange($event,data )"
        >
          <option *ngFor="let option of data.dropDownOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>

      <div class="input-container" *ngIf="data.inputLabel">
        <div class="row">
          <span class="data-label"
            >{{ data.inputLabel }}
          </span>
        </div>
        <input type="text" value="repoLink" [(ngModel)]="data.repoLink" (input)="onRepoLinkChange(data)">
      </div>
  
      <app-file-upload
        [data]="data?.uploadFile ? data.uploadFile : {}"
        (filesSelected)="handleFilesSelected($event, data)"
        class="col-md-12"
      ></app-file-upload>
    </div>
  </div>

  <!-- <button (click)="getAllSelectedData()"> save </button> -->